// ** Initial State
const initialState = {
  exhibitor: [],
  // complementry: [],
  allData: [],
  data: [],
  updateInvite: null,
  bulkEmail: [],
  eventsListData: null,
  eventListWithPagintion: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
  pageLoader: true,
};

const eventlist = (state = initialState, action) => {
  switch (action.type) {
    case "GET_EXHIBITOR":
      return { ...state, exhibitor: action.data };
    case "GET_ALL_EVENTS":
      return { ...state, allData: action.data };
    case "GET_DATA":
      return { ...state, data: action.data };
    case "SET_DATA":
      return { ...state, data: action.data };
    // case 'COMPLEMENT_CREATION':
    //   return { ...state, complementry: action.data }
    case "DELETE_DATA":
      return { ...state, data: action.data };
    //   return { ...state, complementry: action.data }
    case "UPDATE_INVITE":
      return { ...state, updateInvite: action.data };
    case "SET_BULK_EMAIL":
      return { ...state, bulkEmail: action.data };
    case "GET_ALL_INVITATION_WITH_PAGINATION":
      return { ...state, invitationListWithPagintion: action.data, pageLoader: false};
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    case "GET_ALL_EVENTS_LIST_PAGINATED_DATA":
      return { ...state, eventListWithPagintion: action.data, pageLoader: false};
    case "GET_EVENTS_LIST_DATA":
      return { ...state, eventsListData: action.data };
    case "UPDATE_EVENT":
      return { ...state, eventsListData: action.data };
    case "DELETE_EVENT_LIST":
      return { ...state, data: action.data };
    case "UPDATE_DEFAULT_EVENT":
      // const updatedData  = (state?.eventListWithPagintion?.data).map((v,k) => {
      //   return ( v._id === action.data?.data._id)?action.data?.data: v;
      // });
      // const updatedEventListWithPagination = {
      //   ...state.eventListWithPagintion,
      //   data: updatedData,
      // };
      // console.log(updatedEventListWithPagination,'updatedEventListWithPagination');
      // return { ...state };
      return { ...state, data: action.data?.data };
    default:
      return { ...state };
  }
};
export default eventlist;
